import { useState, useEffect } from "react";
import api from "../services/api";
import { useSnackbarAlert } from "../hooks/useSnackbarAlert";

const useDisclaimerFormData = (disclaimer, onClose, onSave) => {
  const snackbar = useSnackbarAlert();

  const [formData, setFormData] = useState({
    name: "",
    displayName: "",
    text: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (disclaimer) {
      setFormData({
        name: disclaimer.name || "",
        displayName: disclaimer.displayName || "",
        text: disclaimer.text || "",
      });
    } else {
      setFormData({ name: "", displayName: "", text: "" });
    }
  }, [disclaimer]);

  const handleChange = (field) => (e) =>
    setFormData({ ...formData, [field]: e.target.value });

  const handleSubmit = async () => {
    if (loading) return;

    const name = formData.name?.trim();
    const displayName = formData.displayName?.trim();
    const text = formData.text?.trim();

    if (!name || !displayName || !text) {
      snackbar.error("All fields are required");
      return;
    }

    try {
      setLoading(true);
      const payload = { name, displayName, text };

      if (disclaimer) {
        await api.put(`/admin/disclaimers/${disclaimer._id}`, payload);
        snackbar.success("Disclaimer updated");
      } else {
        await api.post("/admin/disclaimers", payload);
        snackbar.success("Disclaimer created");
      }

      onSave(); // trigger refresh only
      onClose();
    } catch (err) {
      console.error("Error saving disclaimer:", err);
      snackbar.error(err?.response?.data?.error || "Failed to save disclaimer");
    } finally {
      setLoading(false);
    }
  };

  return {
    formData,
    setFormData,
    handleChange,
    handleSubmit,
    loading,
  };
};

export default useDisclaimerFormData;
